import React from 'react'

const Fees = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Fees</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg " style={{textAlign:'justify',overflow:'hidden'}}>
      <h6>FEES APPLICABLE UNDER RIGHT TO INFORMATION ACT, 2005</h6>

													<ul>
														<li><strong>Application Fee:</strong> Rs 50/- (Rupees fifty
															only)</li><hr/>
														<li><strong>Cost of providing </strong><strong>Information
																:</strong> Rs 2/- per page w.e.f. 01.01.2010</li><hr/>
														<li><strong>No fee will be charged from the person below Poverty
																Line.</strong></li><hr/>
													</ul>
    </div>
    </div>
  )
}

export default Fees
